import {MatDialog} from '@angular/material';
import {User} from '../../model/user.model';
import {Validator} from '../../utils/Validator';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from '../../service/user.service';
import {AnalyticsTracker} from '../../utils/AnalyticsTracker';
import {Keys, StorageService} from '../../service/storage.service';
import {LoginInteractor} from '../../interactors/login.interactor';
import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {LenderDetailsService} from '../../service/lender-details.service';
import {LoanApplicationService} from '../../service/loan-application.service';
import {PreApprovalLoginHelper} from '../../helpers/pre-approval-login.helper';
import {PanVerificationComponent} from '../../pan-verification/pan-verification.component';
import {PanAlreadyPresentPromptComponent} from './pan-already-present-prompt/pan-already-present-prompt.component';

@Component({
    selector: 'app-pan-validator',
    templateUrl: './pan-validator.component.html',
    styleUrls: ['./pan-validator.component.css'],
    providers: [PreApprovalLoginHelper]
})
export class PanValidatorComponent extends PanVerificationComponent implements OnInit {
    @Output() user = new EventEmitter<any>();
    @Output() resetClearPhoneInfo = new EventEmitter<any>();
    @Output() clearEligibilityCheckFormInfo = new EventEmitter<any>();

    private readonly dialog: MatDialog;
    private readonly preApprovalLoginHelper: PreApprovalLoginHelper;
    private readonly loanApplicationService: LoanApplicationService;
    private readonly loginInteractor: LoginInteractor;
    private readonly lenderDetailsService: LenderDetailsService;

    constructor(formBuilder: FormBuilder, validator: Validator, userService: UserService, storageService: StorageService,
                router: Router, activatedRoute: ActivatedRoute, analyticsTracker: AnalyticsTracker, dialog: MatDialog,
                preApprovalLoginHelper: PreApprovalLoginHelper, loanApplicationService: LoanApplicationService,
                loginInteractor: LoginInteractor, lenderDetailsService: LenderDetailsService) {
        super(formBuilder, validator, userService, storageService, router, activatedRoute, analyticsTracker, null);
        this.dialog = dialog;
        this.preApprovalLoginHelper = preApprovalLoginHelper;
        this.loanApplicationService = loanApplicationService;
        this.loginInteractor = loginInteractor;
        this.lenderDetailsService = lenderDetailsService;
    }

    async ngOnInit(): Promise<void> {
        const token = this.storageService.getItem(Keys.TOKEN);
        if (token) {
            this.isPanVerified = true;
            const userId = this.storageService.getItem('profile_id');
            const user = await this.userService.getProfileDetails(userId);
            const {pan_no: pan} = await this.userService.getUserPanAndContactInfo(userId, token);
            this.panFormGroup.patchValue({name: user.name, pan: pan});
        }
    }

    async onPanVerified(): Promise<void> {
        this.isPanVerified = true;
    }

    async onPanAlreadyPresent(formGroup: FormGroup) {
        this.isPanVerified = true;
        const loginId = formGroup.controls.pan.value;
        const {id, maskedPhoneNumber} = await this.loginInteractor.requestLogIn(loginId);
        this.storageService.saveItem(Keys.LOGIN_TOKEN, id);
        const dialogRef = this.dialog.open(PanAlreadyPresentPromptComponent, {
            data: {
                phoneNumber: maskedPhoneNumber,
                loginId: loginId
            }
        });
        const user = await dialogRef.afterClosed().toPromise();
        this.panFormGroup.patchValue({name: user.name});
        this.user.emit(user);
        await this.saveUserInformation(user);
    }

    async onSubmit(formGroup: FormGroup) {
        this.resetClearPhoneInfo.emit();
        await super.onSubmit(this.panFormGroup);
    }

    public clearPanInfo(): void {
        this.clearEligibilityCheckFormInfo.emit();
        this.isPanVerified = false;
        this.panFormGroup.reset();
    }

    public async saveUserInformation(user: User): Promise<void> {
        const [lenderDetails, loanApplications] = await Promise.all([this.lenderDetailsService.getLenderDetailsByProfileId(user._id),
            this.loanApplicationService.getLoanApplicationsByUserId(user._id)]);
        if (loanApplications && loanApplications.length > 0) {
            await this.preApprovalLoginHelper.saveLoanDetails();
            await this.preApprovalLoginHelper.redirectUser();
        }
        if (lenderDetails) {
            await this.preApprovalLoginHelper.saveLenderDetails(lenderDetails);
        }
    }

}
